var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M694.76 540.63a28.83 28.83 0 0 1-20.39-8.43l-365.5-364.99c-11.27-11.27-11.29-29.53-0.03-40.79 11.26-11.31 29.53-11.27 40.8-0.04l365.51 364.99c11.27 11.27 11.29 29.53 0.03 40.79-5.64 5.66-13.03 8.47-20.42 8.47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.24 906.06c-7.39 0-14.78-2.82-20.42-8.47-11.26-11.27-11.24-29.53 0.03-40.79l365.48-365c11.27-11.25 29.53-11.25 40.8 0.04 11.26 11.27 11.24 29.53-0.03 40.79L349.62 897.62a28.777 28.777 0 0 1-20.38 8.44z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDirection);
export default __webpack_public_path__ + "static/media/right-direction.4aab6403229e563184c714abca63f3a2.svg";
export { ForwardRef as ReactComponent };